module.exports = __webpack_public_path__ + "static/media/Position_Gold-Jungle.f5887416.png";